import React, { ReactNode, useEffect, useState } from 'react'
import "../css/Menu.css"
import { Col } from 'react-bootstrap';
interface Props{
    menu: boolean;
    children?: ReactNode;
    
}


const Menu = (props:Props) => {
const [clase, setClase] = useState("abierto");
useEffect(()=>{
    if(props.menu){
        setClase("abierto");
    }else{
        setClase("cerrado")
    }
},[props.menu])
  if(clase=="abierto"){
      
    return (
      <Col sm="2">  
      <div className={clase}>
        {props.children}
        
      </div>
      </Col>
    )
  }  

return (
    
    <div className={clase}>
      {props.children}
      
    </div>
  )
}

export default Menu
